import React from 'react';

import { LTButton, LTText } from '@lambdatestincprivate/lt-components';

import NoResults from '../../assets/no-results';
import styles from './index.module.css';

const Links = {
  SELENIUM:
    'https://www.lambdatest.com/support/docs/selenium-automation-capabilities/',
  CYPRESS: 'https://www.lambdatest.com/support/docs/run-settings/',
};

const ComponentNoDataFound = ({
  iconToRender = undefined,
  secondaryMessage = '',
  message = 'No results found',
  hideHelpLink = true,
  buttonText = '',
  buttonLink = '',
  testType = 'selenium',
  extraStyle = {},
  headerStyle = {},
}) => {
  return (
    <div className={`${styles.message}`} style={extraStyle}>
      {iconToRender ? iconToRender : <NoResults />}
      <div className={styles.textContainer}>
        <LTText
          as={'h2'}
          variant={LTText.TextVariant.HEADER_BOLD}
          style={headerStyle}
        >
          {message}
        </LTText>
        {secondaryMessage && (
          <LTText as={'h4'} variant={LTText.TextVariant.SUBHEADER_REGULAR}>
            {secondaryMessage}
          </LTText>
        )}
        {!hideHelpLink && (
          <div className={styles.link}>
            <a data-testid="no-data-learn-more-link" href={Links[testType.toUpperCase()]} target="_blank">
              Learn More
            </a>
          </div>
        )}
      </div>
      {buttonText && (
        <LTButton
          data-testid="no-data-action-btn"
          onClick={() => {
            window.open(buttonLink, '_self');
          }}
          variant={LTButton.Variant.PRIMARY}
        >
          {buttonText}
        </LTButton>
      )}
    </div>
  );
};

export default ComponentNoDataFound;
